import React from 'react';
import { Input as AntInput } from 'antd';
import type { InputProps } from 'antd';
import clsx from 'clsx';

export const Input = ({ className, ...props }: InputProps) => (
  <AntInput {...props} className={clsx('wk-input', className)} />
);

Input.TextArea = AntInput.TextArea;
Input.Search = AntInput.Search;
Input.Password = AntInput.Password;
Input.Group = AntInput.Group;
